import React, { Component } from 'react'
import PropTypes from 'prop-types'
import CollapseIconButton from 'components/fulcrum/collapse/CollapseIconButton'
import ModifyIconButton from './ModifyIconButton'
import { Flex } from 'reflexbox'
import { mapProps, compose } from 'recompose'
import { GLOBAL_ROLES, PRODUCT_ROLES } from 'containers/Role/constants'
import showOnAnyRoles from 'containers/Role/Show/AnyGlobalRoles'

const Actions = ({id, onSave, edit, onEdit, toggleCollapse, collapse}) => {
  return (
    <Flex justify='flex-end'>
      <ModifyIconButton
        toggleEdit={onEdit}       
        edit={edit}
        onSave={onSave}
        id={id}
      />
      <CollapseIconButton
        toggleCollapse={toggleCollapse}
        collapse={collapse}
      />
    </Flex>
  )
}

export default Actions







